(() => {
  if (window.__hhCollectionQuickAddReady) return;
  window.__hhCollectionQuickAddReady = true;

  const POPOVER = '[data-hh-quick-add-popover]';
  const TOGGLE = '[data-hh-quick-add-toggle]';

  const closePopover = (popover, restoreFocus = false) => {
    if (!popover) return;
    const root = popover.closest('[data-hh-quick-add]');
    const toggle = root?.querySelector(TOGGLE);
    popover.hidden = true;
    toggle?.setAttribute('aria-expanded', 'false');
    if (restoreFocus) toggle?.focus();
  };

  const closeOthers = (current) => {
    document.querySelectorAll(`${POPOVER}:not([hidden])`).forEach((popover) => {
      if (popover !== current) closePopover(popover);
    });
  };

  const setStatus = (root, message) => {
    const status = root?.querySelector('[data-hh-quick-status]');
    if (status) status.textContent = message;
  };

  const feedback = (button, state) => {
    if (!button) return;
    button.classList.remove('is-added', 'is-error');
    void button.offsetWidth;
    button.classList.add(state);
    window.setTimeout(() => button.classList.remove(state), state === 'is-added' ? 720 : 1000);
  };

  const updateHeaderCount = (count) => {
    document.querySelectorAll('[data-hh-cart-count]').forEach((node) => {
      node.textContent = String(count);
      node.hidden = count <= 0;
    });
  };

  const replaceDrawerFromSection = (html, itemCount) => {
    if (!html) return;

    const drawer = document.querySelector('cart-drawer');
    const current = document.getElementById('CartDrawer');
    if (!drawer || !current) return;

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const fresh = parsed.getElementById('CartDrawer');
    if (!fresh) return;

    const wasOpen = drawer.classList.contains('active');

    current.innerHTML = fresh.innerHTML;
    drawer.classList.toggle('is-empty', Number(itemCount || 0) === 0);

    const overlay = current.querySelector('#CartDrawer-Overlay');
    if (overlay && typeof drawer.close === 'function') {
      overlay.addEventListener('click', drawer.close.bind(drawer));
    }

    if (!wasOpen) {
      drawer.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    }
  };

  const fetchCartCount = async () => {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart.js`, {
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      cache: 'no-store',
    });

    if (!response.ok) return null;
    return response.json();
  };

  const addVariant = async (root, variantId) => {
    if (!root || !variantId) return;

    const button = root.querySelector('.hh-collection-card__cart-button');
    if (button?.getAttribute('aria-busy') === 'true') return;

    button?.setAttribute('aria-busy', 'true');
    setStatus(root, '');

    const addedMessage = root.dataset.hhAddedMessage || '';
    const errorMessage = root.dataset.hhErrorMessage || '';

    try {
      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: ['cart-drawer'],
          sections_url: window.location.pathname,
        }),
      });

      const data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || errorMessage || 'Could not add product');
      }

      const cart = await fetchCartCount();
      if (cart) updateHeaderCount(Number(cart.item_count || 0));

      replaceDrawerFromSection(
        data.sections?.['cart-drawer'],
        cart?.item_count
      );

      closePopover(root.querySelector(POPOVER));
      feedback(button, 'is-added');
      setStatus(root, addedMessage);
    } catch (error) {
      console.error('[HIT AND HOPE] Collection quick add failed:', error);
      feedback(button, 'is-error');
      setStatus(root, errorMessage);
    } finally {
      button?.removeAttribute('aria-busy');
    }
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest(TOGGLE);
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();

      const root = toggle.closest('[data-hh-quick-add]');
      const popover = root?.querySelector(POPOVER);
      if (!popover) return;

      const shouldOpen = popover.hidden;
      closeOthers(popover);
      popover.hidden = !shouldOpen;
      toggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');

      if (shouldOpen) {
        popover.querySelector('[data-hh-quick-variant]')?.focus({ preventScroll: true });
      }
      return;
    }

    const option = event.target.closest('[data-hh-quick-variant]');
    if (option) {
      event.preventDefault();
      event.stopPropagation();
      addVariant(option.closest('[data-hh-quick-add]'), option.dataset.hhQuickVariant);
      return;
    }

    const direct = event.target.closest('[data-hh-quick-add-direct]');
    if (direct) {
      event.preventDefault();
      event.stopPropagation();
      addVariant(direct.closest('[data-hh-quick-add]'), direct.dataset.variantId);
      return;
    }

    if (!event.target.closest('[data-hh-quick-add]')) closeOthers(null);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const popover = document.querySelector(`${POPOVER}:not([hidden])`);
    if (popover) closePopover(popover, true);
  });
})();
